
import Footer from "../components/footer";
import Header from "../components/header";
import React, { useState, useRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function LeaveMark() {
 const { t, i18n } = useTranslation();
  const location = useLocation();


 
  // Doğru component adı
  const howItWorksSteps = [
    {
      number: "1",
      title: t("How2UseDot1"),
      items: [
        t("How2UseDot1Desc"),
        t("How2UseDot1Desc2"),
        t("How2UseDot1Desc3"),
      ],
    },
    {
      number: "2",
      title: t("How2UseDot2"),
      items: [
        t("How2UseDot2Desc"),
        t("How2UseDot2Desc2"),
        t("How2UseDot2Desc3"),
      ],
    },
    {
      number: "3",
      title: t("How2UseDot3"),
      items: [
        t("How2UseDot3Desc"),
        t("How2UseDot3Desc2"),
        t("How2UseDot3Desc3"),
       
      ],
    },
  ];

  const usageLocations = [
    {
      image: "/assets/whereUsed-1.png",
      title:  t("WhereCanIUseItDot1"),
      description:
        t("WhereCanIUseItDot1Desc"),
    },
    {
      image: "/assets/whereUsed-2.png",
      title: t("WhereCanIUseItDot2"),
      description: t("WhereCanIUseItDot2Desc"),
    },
    {
      image: "/assets/whereUsed-3.png",
      title: t("WhereCanIUseItDot3"),
      description:
        t("WhereCanIUseItDot3Desc"),
    },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <Header isHomePage={false} />

      {/* Hero Section */}

      <section className="relative w-full h-[220px] sm:h-[220px] md:h-[440px] lg:h-[440px] overflow-hidden ">
        <div className="absolute inset-0 ">
          <img
            src="/assets/izinibirakbg.png"
            alt="Keşfet"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 flex items-end  ">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 pb-4 sm:pb-8 md:pb-12 lg:pb-16   lg:px-10 xl:px-28">
            <h2 className="text-3xl md:text-[42px] font-bold sm:text-3xl md:text-4xl lg:text-[54px]  font-poppins text-white text-start  sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl mx-auto sm:mx-0">
              {t("LeaveMark")}
            </h2>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="container mx-auto px-4 py-6 sm:py-8 md:py-12 lg:py-16 ">
        <div className=" px-4 lg:px-10 xl:px-24 ">
          {/* Adjusted responsive text sizes */}
          <h1 className="text-3xl md:text-[42px] font-bold font-poppins   sm:text-2xl md:text-3xl lg:text-[45px]   text-[#2F327D] mb-3 sm:mb-4 md:mb-6 lg:mb-8 text-left md:leading-[60px] lg:leading-[60px]">
            {t("LeaveMarkTitle")}
          </h1>

          {/* Adjusted responsive text sizes, capped at md */}
          <p className="text-lg md:text-[21px] font-poppins   text-[#797979]  text-left lg:leading-[30px]">
            {t("LeaveMarkDesc")}
          </p>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="container mx-auto px-4 ">
        <div className="px-4 lg:px-10 xl:px-24 mx-auto">
          {/* Adjusted responsive text sizes */}
          <h1 className="text-3xl md:text-[42px] font-bold   font-poppins text-[#2F327D] mb-4 sm:mb-6 md:mb-8 text-left">
           {t("How2Use")}
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {howItWorksSteps.map((step, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg border shadow-[#FEF6F7] border-[#FEF6F7] p-4 sm:p-5 md:p-6 transition hover:shadow-lg h-auto flex flex-col"
              >
                <div className="w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] md:w-[70px] md:h-[70px] rounded-xl sm:rounded-2xl bg-[#FEECEC] flex items-center justify-center mb-3 sm:mb-4">
                  <span className="text-[#FF5A5F] font-semibold font-podkova text-2xl sm:text-3xl md:text-[36px]">
                    {step.number}
                  </span>
                </div>
                {/* Adjusted responsive text sizes, capped at md */}
                <h3 className="font-bold text-lg md:text-xl font-poppins   sm:text-lg   text-[#292D33] mb-3 sm:mb-4 md:mb-6 text-left">
                  {step.title}
                </h3>
                {/* Kept existing responsive text sizes */}
                <ul className="list-inside font-poppins text-lg sm:text-sm md:text-base text-[#9497A1] space-y-1.5 sm:space-y-2 text-left flex-grow">
                  {step.items.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      className="leading-tight sm:leading-normal md:leading-relaxed"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Where to Use Section */}
      <section className="container px-4 lg:px-10 xl:px-24  text-left mx-auto py-6 sm:py-8 md:py-12 lg:py-16 ">
        <div className="  mx-auto">
          {/* Adjusted responsive text sizes */}
          <h1 className="  pl-5 sm:pl-0 md:pl-0 lg:pl-0 text-3xl md:text-[42px] font-bold text-[#2F327D] font-poppins   mb-4 sm:mb-6 md:mb-8 text-left">
            {t("WhereCanIUseIt")}
          </h1>
          {/* Adjusted responsive text sizes, capped at md */}
          <p className="text-lg md:text-[21px] font-poppins pl-5 sm:pl-0 md:pl-0 lg:pl-0   text-left sm:text-base   text-[#797979] mb-6 sm:mb-8 md:mb-10">
            {t("WhereCanIUseItDesc")}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {usageLocations.map((location, index) => (
              <div
                key={index}
                className={`${
                  index === 1 ? "bg-[#F9F9F9]" : ""
                } rounded-lg sm:rounded-xl  overflow-hidden`}
              >
                <img
                  src={location.image}
                  alt={location.title}
                  className="w-full h-auto p-4 "
                  loading="lazy"
                />
                <div className="p-3 sm:p-4 md:p-6">
                  {/* Adjusted responsive text sizes, capped at md */}
                  <h2 className="text-xl sm:text-lg md:text-[24px] font-poppins font-semibold text-[#242331] mb-2 sm:mb-3 md:mb-4 text-center">
                    {location.title}
                  </h2>
                  {/* Kept existing responsive text sizes */}
                  <p className="text-gray-600 text-lg sm:text-sm md:text-[16px] font-poppins  text-center">
                    {location.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leave Mark Section */}
      <section className="bg-[#FDECEE] py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-4 md:px-6">
          {/* Adjusted responsive text sizes */}
          <h2 className="text-3xl md:text-[42px] font-bold text-[#2F327D] font-poppins   text-center mb-6 sm:mb-8 md:mb-10 lg:mb-12 max-w-[683px] mx-auto leading-tight sm:leading-snug md:leading-normal">
            {t("DownloadApp")}
          </h2>
          <div className="relative w-full max-w-[871px] mx-auto px-4 sm:px-6 md:px-8">
            <img
              src="/assets/leave-mark.png"
              alt="Mobil uygulama görseli"
              className="w-full h-auto object-contain rounded-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* <section className="container mx-auto px-4 py-8 sm:py-8 md:py-12 lg:py-20">
        <div className="max-w-[1182px] max-h-[493px] mx-auto relative">
          <div className="w-full overflow-hidden rounded-[20px] sm:rounded-[24px] md:rounded-[28px] lg:rounded-[32px]">
            <img
              src="/assets/mockupbgdw.png"
              alt="Premium İndir Arka Plan"
              className="w-full min-h-[200px] object-cover"
              loading="lazy"
            />
          </div>

          <div className="absolute inset-0 flex flex-col justify-center items-start p-4 sm:p-8 md:p-12 lg:p-16">
                <div className="sm:max-w-[300px] md:max-w-[420px] lg:max-w-[482px] p-2 sm:py-16 md:py-12 mt-[6px] sm:mt-20 text-left">
                  <h2 className="sm:text-base md:text-3xl lg:text-[40px] tracking-[1px] sm:tracking-[2px] font-semibold text-white font-poppins leading-none sm:leading-tight sm:pb-2 md:pb-4 lg:pb-6 text-left">
                    UYGULAMAYI İNDİR & <br className="xs:block" />
                    <span className="sm:mt-[12px]  mb-4 sm:mb-8 inline-block">
                      KEŞFETMEYE BAŞLA!
                    </span>
                  </h2>
                  <p className="text-white text-[10px] sm:text-sm md:text-base lg:text-xl font-medium font-poppins leading-none sm:leading-normal text-left">
                    App Store ve Google Play'de!{" "}
                    <br className="block sm:hidden" />
                    <span className="mt-[6px] sm:mt-0 sm:ml-1 inline-block">
                      Ücretsiz indir,
                    </span>
                    <br className="sm:block" />
                    <span className="mt-[6px] inline-block">
                      premium özellikleri keşfet.
                    </span>
                  </p>
                  <div className="flex flex-row items-center gap-2 sm:gap-3 md:gap-4 pt-2 sm:pt-3 md:pt-4">
                    <a
                      href="https://apps.apple.com/app/qriend"
                      className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                    >
                      <img
                        src="/assets/appStore.svg"
                        alt="App Store'dan İndir"
                        className="w-full h-auto"
                        loading="lazy"
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.qriend"
                      className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                    >
                      <img
                        src="/assets/googlePlay.svg"
                        alt="Google Play'den İndir"
                        className="w-full h-auto"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              </div>
        </div>
      </section> */}

      {/* Footer */}
      <Footer isHomePage={false} />
    </div>
  );
}
